module.exports = __webpack_public_path__ + "img/DSC_0180 teatro ilpa aire libre.ba01e8e3.jpg";